import script from "./CompanyToplist.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyToplist.vue?vue&type=script&setup=true&lang=js"

import "./CompanyToplist.vue?vue&type=style&index=0&id=6565466d&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6565466d"]])

export default __exports__